import {
  LegalClientEntity,
  LegalClientRepresentativeEntity,
} from 'api/types/entity';
import { useLockLegalClient } from 'modules/client/legal/hooks/useLockLegalClient';

export const useLockLegalClientRepresentative = (
  legalClient: LegalClientEntity | null,
  representative: LegalClientRepresentativeEntity | null
) => {
  const { lockClientIfPossible, unlockClient } = useLockLegalClient(
    legalClient
      ? {
          ...legalClient,
          versionNumber: representative?.versionNumber,
        }
      : null
  );

  return { lockClientIfPossible, unlockClient };
};
